import { useWSMutation, WSMutationsConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../utils/serviceHelper";
import { QUERY_BENEFITS_PLAN_ENROLLMENT } from "./useQueryPlanEnrollment";
import { QUERY_BENEFITS_PLAN_ENROLLMENTS } from "./useQueryPlanEnrollments";
import { cancelPlanEnrollment } from "../../services/api/planEnrollment/cancelPlanEnrollment";
import { queriesAuditLogs } from "../../v3/query/queriesAuditLogs";
import { queriesInsuranceCoverages } from "../../v3/query/queriesInsuranceCoverages";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;

export const useMutationCancelPlanEnrollment = (
  config?: WSMutationsConfig<IPlanEnrollment, WSServiceError, string>
) =>
  useWSMutation<IPlanEnrollment, WSServiceError, string>(
    (planEnrollmentId: string) => cancelPlanEnrollment(planEnrollmentId),
    {
      dependencies: [
        QUERY_BENEFITS_PLAN_ENROLLMENT,
        QUERY_BENEFITS_PLAN_ENROLLMENTS,
        queriesInsuranceCoverages.getInsuranceCoverage.queryKeyBase,
        queriesInsuranceCoverages.listInsuranceCoverages.queryKeyBase,
        queriesAuditLogs.listAuditLogs.queryKeyBase
      ],
      ...config
    }
  );
